import TermsCheckbox from "./TermsCheckbox"

export default TermsCheckbox
